import { formatDate } from '../../utils';

const transformPathwaysWithCount = (data) => {
  const { results, count, conditions, timings, actions, triggers } = data;
  if (results) {
    return {
      results: results.map(({ createdAt, ...item }) => ({
        ...item,
        createdOn: formatDate(createdAt),
      })),
      count,
    };
  }
  return conditions && timings && actions && triggers
    ? { conditions, timings, actions, triggers }
    : null;
};

export default transformPathwaysWithCount;
